export type TenantData = {
  id?: string
  default_language_tag: string
  details: string
  name: string
  subdomain: string
  is_parent?: boolean
}

export type TenantLogin = {
  id?: string
  subdomain: string
}

export type CustomResponse<Data> = {
  status: SuccessStatusCode
  success?: boolean
  message?: string
  statusText: string
  data?: Data
}

export type CustomError = {
  status: ErrorStatusCode
  statusText: string
  message?: string
  messageKey?: string
  data: null
}

export enum ErrorStatusCode {
  Unauthorized = 401,
  Forbidden = 403,
  NotFoundError = 404,
  Conflicted = 409,
  Unprocessable = 422,
  TooManyRequests = 429,
  InternalServerError = 500,
}

export enum SuccessStatusCode {
  Ok = 200,
  Created = 201,
  NoContent = 204,
  Accepted = 202,
}

export const FormOfAddress = {
  NOT_APPLICABLE: 'not_applicable',
  FORMAL: 'formal',
  INFORMAL: 'informal',
} as const

// Languages included with every package at no extra cost. Mirrors the backend
// FREE_LANGUAGE_TAGS constant. Regional variants (en-US, de-CH, ...) are paid
// and consume the subscription's custom_language_count cap. The server is the
// cap authority; this constant is display-only (free vs paid chip styling).
export const FREE_LANGUAGE_TAGS = ['de-DE', 'en-GB', 'fr-FR', 'it-IT', 'es-ES'] as const
